// extracted by mini-css-extract-plugin
module.exports = {"title":"LowConfidenceToolTipWarning_title__1ZOZ4","describe":"LowConfidenceToolTipWarning_describe__2wPQg","buttonGroup":"LowConfidenceToolTipWarning_buttonGroup__aqP-N"};